import { useStaticQuery, graphql } from 'gatsby';

export const useNotificationPages = () => {
  const { allStoryblokEntry } = useStaticQuery(graphql`
    query NotificationQuery {
      allStoryblokEntry(filter: { field_component: { eq: "notification" } }) {
        nodes {
          uuid
          content
          lang
        }
      }
    }
  `);

  //

  const res = allStoryblokEntry.nodes
    .filter(
      (n) =>
        //n.field_publish_end_string < 0 &&
        n.lang === process.env.GATSBY_STORYBLOK_LANGUAGE,
    )
    .map((n) => JSON.parse(n.content));

  return res;
};
